import React from 'react';

import searchIcon from '@images/Search.svg';

import * as styles from './search-form.module.scss';

export const SearchForm = ({ handleInput, searchTerm }) => {
  return (
    <form className={styles.searchForm} onSubmit={(e) => e.preventDefault()}>
      <input type="text" placeholder="Search using keywords" value={searchTerm} onChange={handleInput} />
      <button>
        <img loading="lazy" src={searchIcon} alt="search" />
      </button>
    </form>
  );
};
